import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from './Auth/AuthContext';
import '../assets/styles/Navbar.css';
import uumcLogo from "../assets/images/uumc-logo.jpg";

const pageTitles = {
    '/': 'Home',
    '/attendees': 'Attendance Record',
    '/filter-by-year': 'Filter by Year',
    '/filter-by-month': 'Filter by Month',
    '/filter-by-user': 'Filter by User'
}

const Navbar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { user, logout } = useAuth();

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    const pageTitle = pageTitles[location.pathname] || 'Attendance';
    const isHome = location.pathname === '/';

    return (
        <nav className='uumc-navbar'>
            <div className='uumc-leftSec'>
                <div className='logo'>
                    <img className='uumcLogo' src={uumcLogo}/>
                </div>
                <span className='brand'>UUMC Attendance</span>
                {!isHome && (
                    <>
                        <span className='uumc-navbar-seperator'></span>
                        <span className='uumc-navbar-pagetitle'>{pageTitle}</span>
                    </>
                )}
            </div>
            <div className='uumc-rightSec'>
                {!isHome && (
                    <button className="uumc-navbar-homebtn" onClick={() => navigate('/')}>
                        ← Home
                    </button>
                )}
                {user && <span className="uumc-navbar-username">{user.name}</span>}
                <button className="uumc-navbar-logoutbtn" onClick={handleLogout}>
                    Sign out
                </button>
            </div>
        </nav>
    )
}



// const NavBar = () => {

//     const { tabs } = useQueryTabs();

//     return (
//         <div className="tab-bar">
//             {tabs.map((tab, index) => (
//                 <span key={index} className="tab">{tab}</span>
//             ))}
//         </div>
//     );
// }

export default Navbar;